{
  "version": 1,
  "asset_id": "28a99f0f-d810-45ea-b57c-5b4868b8a01b",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/28a99f0f-d810-45ea-b57c-5b4868b8a01b/Bypass_Postoperative_Diet.pdf",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/28a99f0f-d810-45ea-b57c-5b4868b8a01b/Bypass_Postoperative_Diet.pdf",
  "original_filename": "Bypass_Postoperative_Diet.pdf",
  "size": 146518,
  "content_type": "application/pdf",
  "created_at": "2026-07-21T00:24:51Z"
}
